//自定义权限判断指令
/**
 * 必须包含列出的所有权限，元素才显示
 */
export const hasAllPermission = {
  install(Vue) {
    Vue.directive("hasAllPermission", {
      bind(el, binding, vnode) {
        //用户所用的所有权限
        let permissions = vnode.context.$store.state.user.permissions;
        //当前绑定的权限
        let value = binding.value.split(",");
        //是否存在
        let flag = true;
        for (let v of value) {
          if (!permissions.includes(v)) {
            flag = false;
          }
        }
        if (!flag) {
          if (!el.parentNode) {
            el.style.display = "none";
          } else {
            el.parentNode.removeChild(el);
          }
        }
      }
    });
  }
};
/**
 * 只要包含列出的任意一个权限，元素就会显示
 */
export const hasAnyPermission = {
  install(Vue) {
    Vue.directive("hasAnyPermission", {
      bind(el, binding, vnode) {
        let permissions = vnode.context.$store.state.user.permissions;
        let value = binding.value.split(",");
        let flag = false;
        for (let v of value) {
          if (permissions.includes(v)) {
            flag = true;
          }
        }
        if (!flag) {
          if (!el.parentNode) {
            el.style.display = "none";
          } else {
            el.parentNode.removeChild(el);
          }
        }
      }
    });
  }
};
